import {
  AvatarProps,
  Avatar as MUIAvatar,
  Theme,
  makeStyles,
} from "@material-ui/core";
import classNames from "classnames";
import { LG, MD, SM } from "../../types";
import { styles } from "./styles";

export interface ICompanyAvatarProps extends AvatarProps {
  size?: SM | MD | LG;
}

const useStyles = makeStyles<Theme, ICompanyAvatarProps>(styles);

const CompanyAvatar = (props: ICompanyAvatarProps) => {
  const { children, size, ...rest } = props;
  const classes = useStyles(props);

  const rootClassName = classNames(classes.root, size && classes[size]);

  return (
    <MUIAvatar className={rootClassName} {...rest}>
      <div />
      {children}
    </MUIAvatar>
  );
};

export default CompanyAvatar;
